import React from 'react';
import { Label, Heading } from '@americanexpress/dls-react';

function Fee({ content }) {
    return (
        <div className="">
            <Heading level="3" className="margin-2-b heading-3 text-uppercase">Annual Fee</Heading>
            {content && !content.annualFeeText && (
                <div className="stack">
                    <div>
                        <Heading level={4} headingStyle="heading3">First year fee: </Heading>
                        <Label className="body-1" >{content.firstYearFeeText}</Label>
                    </div>
                    <div>
                        <Heading level={4} headingStyle="heading3">Second year onwards: </Heading>
                        <Label className="body-1" >{content.secondYearFeeText}</Label>
                    </div>
                </div>
            )
            }
            {content && content.annualFeeText && (
                <div>
                    <Label className="body-1" >{content.annualFeeText}</Label>
                </div>
            )
            }
        </div>

    );
}

export default Fee;